import { Button } from "@mui/material";
import React, { useState } from "react";
import UserDialog from "./user-dialog";

export interface Props {
    form_info: any;
}

const ManageUsers = ({ form_info }: Props) => {
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);

    const handleClick = () => {
        setDialogOpen(true);
    };

    return (
        <div className="mx-1 mb-2">
            <Button variant="outlined" size="large" onClick={handleClick} fullWidth>
                Manage Users
            </Button>
            <UserDialog open={dialogOpen} setDialogOpen={() => setDialogOpen(false)} data={form_info} />
        </div>
    );
};

export default ManageUsers;
